import { useEffect } from 'react';

import { useClickstreamCallback } from '@zenbusiness/application-commons-clickstream';
import { useIdentity } from '@zenbusiness/application-commons-identity';

import isWebView from '#client/utils/isWebView';

function IdentityManager() {
  const { loading, identified, user } = useIdentity();
  const handleUserIdentified = useClickstreamCallback('userIdentified', null, {
    pick: ['userId_', 'userUuid']
  });

  useEffect(() => {
    if (loading) {
      return;
    }
    if (!identified) {
      return;
    }
    if (isWebView) {
      handleUserIdentified({
        userId_: user.userUuid,
        userUuid: user.userUuid
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, identified, user?.accountEmail]);

  if (!identified) {
    return null;
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <></>;
}

export default IdentityManager;
